import { Body1, Link, Spinner, Title2 } from "@fluentui/react-components";
import { useEffect } from "react";
import { useStyles } from "./weHaveMovedPage.styles";

const REDIRECT_DELAY_MS = 10000;

interface IWeHaveMovedPageProps {
  newUrl: string;
}

export const WeHaveMovedPage = ({
  newUrl,
}: IWeHaveMovedPageProps): JSX.Element => {
  const styles = useStyles();
  const newDomain = new URL(newUrl).host;

  useEffect(() => {
    document.title = "We have moved";
  }, []);

  useEffect(() => {
    const timeout = setTimeout(
      () => window.location.replace(newUrl),
      REDIRECT_DELAY_MS,
    );
    return () => clearTimeout(timeout);
  }, [newUrl]);

  return (
    <main className={styles.wrapper}>
      <Spinner size="large" aria-label="Redirecting" />
      <Title2 as="h1">We have moved</Title2>
      <Body1 className={styles.message}>
        You are being redirected to{" "}
        <Link href={newUrl} className={styles.link}>
          {newDomain}
        </Link>
      </Body1>
    </main>
  );
};
